import type { RecruitmentEvaluationResponsePagedData } from '@on3/api';
import Link from 'next/link';
import { useRouter } from 'next/router';

import { ScoutingMock } from './Mock';
import { ScoutingJournalItem } from './ScoutingJournalItem';
import styles from './ScoutingJournalModule.module.scss';

interface ScoutingJournalModuleProps
  extends RecruitmentEvaluationResponsePagedData {}

export const ScoutingJournalModule = ({
  list = [],
}: ScoutingJournalModuleProps) => {
  const router = useRouter();

  if (!list?.length) {
    return <ScoutingMock />;
  }

  return (
    <div className={styles.block}>
      {list?.length && (
        <div className={styles.list}>
          {list.slice(0, 1).map((item) => (
            <ScoutingJournalItem {...item} key={item.key} />
          ))}
        </div>
      )}
      <footer className={styles.footer}>
        <Link href={`/db/${router.query.id}/scouting-journals/`}>
          View All Reports
        </Link>
      </footer>
    </div>
  );
};
